import { DuplicateQuotationIcon } from "components/ui/icons/quotations/DucplicateQuotationIcon"
import { useSearchParams } from "react-router-dom"
import { useCreateQuotation } from "hooks/api/quotation/quotations.hook"
import { useMessage } from "hooks/message.hook"
import { useQueryClient } from "@tanstack/react-query"
import { useApiErrorFormatter } from "hooks/apiErrorFormatter.hook"
import { PencilIcon } from "components/ui/icons/objectsTable/dropdown/PencilIcon"
import type { MenuProps } from "antd"
import style from "./TableQuotations.module.scss"

const { dropdownIcon } = style

export const TableQuotationsDropdownItems = (renameQuotation: (quotationId: number) => void) => {
	const [searchParams] = useSearchParams()
	const url = window.location.href
	const drawingId = Number(searchParams.get("drawingID"))
	const queryClient = useQueryClient()

	const { success: successMessage } = useMessage()
	const { mutate: createQuotationMutation } = useCreateQuotation()
	const { formatError } = useApiErrorFormatter()

	const duplicateQuotationHandle = (quotationId: number) => {
		const urlWithQuotation = new URL(url)
		urlWithQuotation.searchParams.set("quotationID", String(quotationId))

		createQuotationMutation(
			{
				drawing_id: drawingId,
				source_entity_id: quotationId,
				source_entity_type: "quotation",
				source_url: urlWithQuotation.toString(),
				processing_url: url,
			},
			{
				onSuccess: () => {
					successMessage("Quotation created successfully")
					queryClient.invalidateQueries({ queryKey: ["quotations"] })
				},
				onError: (error) => {
					formatError(error)
				},
			},
		)
	}

	const getDropdownItems = (quotationId: number): MenuProps["items"] => [
		{
			key: "1",
			label: "Duplicate and start quotation",
			onClick: () => duplicateQuotationHandle(quotationId),
			icon: <DuplicateQuotationIcon className={dropdownIcon} />,
		},
		{
			key: "2",
			label: "Rename",
			icon: <PencilIcon className={dropdownIcon} />,
			onClick: () => renameQuotation(quotationId),
		},
	]

	return { getDropdownItems }
}
